// @ts-check
if (!customElements.get("ff-flex-grid")) {
  class FfFlexGrid extends HTMLElement {
    constructor() {
      super();

      /**
       * @type {HTMLElement}
       */
      this.ffGrid = (() => {
        if (this.dataset.ffContentSelector) {
          /**
           * @type {HTMLElement | null}
           */
          const ffGrid = this.querySelector(this.dataset.ffContentSelector);

          if (ffGrid) {
            return ffGrid;
          } else {
            throw new Error(
              `Couldn't be found an element with the selector: ${this.dataset.ffContentSelector}`
            );
          }
        } else {
          throw new Error("Missing grid selector");
        }
      })();
      this.ffInit();
    }

    ffInit() {
      if (this.ffGrid?.children && this.ffGrid.children.length > 1) {
        /**
         * @type {HTMLElement[]}
         */
        this.ffCells = Array.from(this.ffGrid.children);

        const { ffMobileBreakpoint } = this.dataset;

        if (
          !ffMobileBreakpoint ||
          window.matchMedia(`(min-width:${ffMobileBreakpoint}px)`).matches
        ) {
          var resizeCells = this.dataset.hasOwnProperty("ffResizeCells");
        } else {
          var resizeCells = this.dataset.hasOwnProperty("ffResizeCellsMobile");
        }

        if (resizeCells) {
          if (this.dataset.hasOwnProperty("ffSoftResize")) {
            this.ffSoftResize();
          } else {
            this.ffResizeCells();
          }
        }

        if (Shopify.designMode) {
          window.removeEventListener(
            "resize",
            this.ffShopifySectionLoadHandler
          );
          window.addEventListener("resize", this.ffShopifySectionLoadHandler);
        }
      }
    }

    ffResizeCells(height) {
      this.ffCells?.forEach((cell) => {
        cell.style.minHeight = `${height}px`;
      });
    }

    ffGetHigherCellHeight() {
      let highestHeight = 0;
      this.ffCells?.forEach(({ clientHeight }) => {
        if (clientHeight > highestHeight) {
          highestHeight = clientHeight;
        }
      });
      return highestHeight;
    }

    ffSoftResize() {
      this.ffGrid.style.setProperty(
        "--ff-flext-grid-resize-height",
        this.ffGetHigherCellHeight() + "px"
      );
    }

    ffShopifySectionLoadHandler = () => {
      if (this.hasAttribute("data-ff-resize-cells")) {
        this.ffCells?.forEach((cell) => {
          cell.style.minHeight = "";
        });

        this.ffGrid.style.setProperty(
          "--ff-flext-grid-resize-height",
          0 + "px"
        );

        setTimeout(() => {
          this.ffInit();
        }, 200);
      }
    };
  }

  customElements.define("ff-flex-grid", FfFlexGrid);
}

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    requestAnimationFrame(() => {
      document.querySelectorAll("ff-flex-grid").forEach((cell) => {
        cell.ffShopifySectionLoadHandler();
      });
    });
  });
}
